import React from 'react';
export function PlayStoreButton({
  className = ''
}: {
  className?: string;
}) {
  return <a href="https://play.google.com/store/apps/details?id=co.pixo.croon" target="_blank" rel="noopener noreferrer" className={`flex items-center gap-2 bg-black text-white px-4 py-2 rounded-full hover:scale-105 transition-transform ${className}`} data-id="element-68" data-mp="32voycr42sdq7">
      <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current" aria-hidden="true" data-id="element-69" data-mp="2t3ssuuzntlby">
        <path d="M3.06.53A1.7 1.7 0 0 0 2.4 1.9v20.2c0 .56.24 1.06.66 1.37l10.2-11.47L3.06.53zm11.6 10.3 3.02-3.4 3.6 2.04c1.14.65 1.14 2.4 0 3.05l-3.6 2.04-3.02-3.4-.02-.16.02-.17zM13.9 12.6l3.02 3.4-11.9 6.74c-.5.28-1 .3-1.42.09L13.9 12.6zm0-1.2L3.6.77c.42-.2.92-.19 1.42.1l11.9 6.73-3.02 3.4z" data-id="element-70" data-mp="2k57d17lkokev" />
      </svg>
      <div className="flex flex-col items-start" data-id="element-71" data-mp="4dt9l9qtbh6i">
        <span className="text-[10px] leading-none" data-id="element-72" data-mp="4f4drao66qy5">GET IT ON</span>
        <span className="text-sm font-bold leading-none mt-1" data-id="element-73" data-mp="8ewnhqpav353">Google Play</span>
      </div>
    </a>;
}